/**
 * Tenant-aware favicon: generates an SVG data-URL using the tenant's primary
 * color + first letter of its name, and swaps the document's <link rel="icon">.
 * Falls back to the default Axia mark when no tenant is resolved.
 */

const DEFAULT_HREF = "/favicon.svg";
const DEFAULT_APPLE = "/apple-touch-icon.svg";
const DEFAULT_TITLE = "Axia · Performance, aligned.";

const _isLight = (hex) => {
  // YIQ contrast: returns true if the bg color is light enough to need dark text
  if (!hex || hex[0] !== "#") return false;
  const h = hex.replace("#", "");
  if (h.length !== 6) return false;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 160;
};

const _initial = (name) => {
  const ch = (name || "A").trim().charAt(0).toUpperCase();
  return /[A-Z]/.test(ch) ? ch : "A";
};

const _svg = ({ primary_color, name }) => {
  const bg = primary_color || "#0F172A";
  const fg = _isLight(bg) ? "#0F172A" : "#FFFFFF";
  const letter = _initial(name);
  return `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64' width='64' height='64'>
    <rect width='64' height='64' rx='14' fill='${bg}'/>
    <text x='32' y='44' text-anchor='middle' font-family='-apple-system,Segoe UI,Roboto,sans-serif' font-size='38' font-weight='800' fill='${fg}'>${letter}</text>
  </svg>`;
};

const _toDataUrl = (svg) =>
  "data:image/svg+xml;utf8," + encodeURIComponent(svg);

const _setLink = (rel, href) => {
  let l = document.querySelector(`link[rel='${rel}']`);
  if (!l) {
    l = document.createElement("link");
    l.rel = rel;
    document.head.appendChild(l);
  }
  l.href = href;
};

export function applyTenantBranding(tenant) {
  if (!tenant || !tenant.name) {
    resetBranding();
    return;
  }
  const href = _toDataUrl(_svg(tenant));
  _setLink("icon", href);
  _setLink("apple-touch-icon", href);
  document.title = `${tenant.name} · Axia`;
}

export function resetBranding() {
  _setLink("icon", DEFAULT_HREF);
  _setLink("apple-touch-icon", DEFAULT_APPLE);
  document.title = DEFAULT_TITLE;
}
